"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VueApollo = void 0;
// This proxy module purpose is to reduce dependencies on UI App and UI Admin for the following packages:
// vue-apollo
// > apollo-client
// > apollo-link
const vue_apollo_1 = __importDefault(require("vue-apollo"));
exports.VueApollo = vue_apollo_1.default;
